import React from "react";
import Loads from "pages/Loads/Loads";

const LiveTracking: React.FC = () => {
  return (
    <Loads
      readOnly
      breadcrumbLabel="Flight Status"
      
     
    />
  );
};

export default LiveTracking;
